import { create } from 'zustand';
import { ActionStoreInterface } from './types';
import { ActionStatus } from '../constants/actions';

const ActionStore = create<ActionStoreInterface>()((set) => {
  return {
    status: ActionStatus.UNINITIATED,
    setStatus: (actionStatus) => {
      set(() => ({
        status: actionStatus,
      }));
    },
  };
});

export default ActionStore;
